import React, { useState, useEffect } from 'react'; 
import { useStore } from '../states/store';
import HLBackendV1Api from '../utils/http/api';
import Tooltip from '@mui/material/Tooltip';

export default function DrawHistory() {

    const { timerStatus, openDrawHistory, isDrawHistoryOpen, drawHistoryData } = useStore();
    const [ drawResults, setDrawResults ] = useState([]);

    const getchDrawResults = async() => {
        try {
            await HLBackendV1Api.get(`${process.env.BACKEND_API_URL}/hl-game-management/history-listings-by-result?page=0&limit=8`)
            .then((response) => { 
                setDrawResults(response.data);
            });
        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        //getchDrawResults();
    }, []);



    return <>
        <div className={"flex flex-row justify-end text-center gap-1 w-full p-2 max-sm:justify-center max-sm:w-dvw tooltip"}>
            { drawHistoryData && drawHistoryData.map(result => (
                <div key={result.id} className={"hover:cursor-pointer hover:scale-110 animate-on-load transition-all duration-300"} onClick={() => openDrawHistory(result.id)}>
                    { result.result === 'up' && (
                        <Tooltip disableFocusListener title={
                            <>
                                <div className='grid grid-cols-2 gap-1 font-bold text-green-500'>
                                    <span>결과:</span>
                                    <span className='uppercase'>{result.result === 'up' ? '업': result.result === 'down' ? '다운': '무승부'}</span>
                                    <span>시작가:</span>
                                    <span className='uppercase'>{result.draw_open_price}</span>
                                    <span>종료가:</span>
                                    <span className='uppercase'>{result.draw_close_price}</span>
                                    <span>요율 변화:</span>
                                    <span className='uppercase animate-bounce underline font-extrabold'>+{result.result_percentage_change}</span>
                                </div>
                            </>
                        } arrow>
                            <div className="hover:cursor-pointer animate-on-load bg-gradient-to-t from-emerald-900 from-10% to-80% h-10 w-10 flex items-center justify-center rounded-xl border-1 border-slate-600 aspect-square text-green-500 drop-shadow-md max-sm:h-8 max-sm:w-8" data-tip="up">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2.5} stroke="currentColor" className="size-6">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="m15 11.25-3-3m0 0-3 3m3-3v7.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                                </svg>
                            </div>
                        </Tooltip>
                        
                    )}
                    { result.result === 'down' && (
                        <Tooltip disableFocusListener title={
                            <>
                                <div className='grid grid-cols-2 gap-1 font-bold text-pink-300'>
                                    <span>결과:</span>
                                    <span className='uppercase'>{result.result === 'up' ? '업': result.result === 'down' ? '다운': '무승부'}</span>
                                    <span>시작가:</span>
                                    <span className='uppercase'>{result.draw_open_price}</span>
                                    <span>종료가:</span>
                                    <span className='uppercase'>{result.draw_close_price}</span>
                                    <span>요율 변화:</span>
                                    <span className='uppercase animate-bounce underline font-extrabold'>{result.result_percentage_change}</span>
                                </div>
                            </>
                        } arrow>
                            <div className="hover:cursor-pointer animate-on-load bg-gradient-to-t from-pink-900 from-10% to-80% h-10 w-10 flex items-center justify-center rounded-xl border-1 border-slate-600 aspect-square text-pink-500 drop-shadow-md max-sm:h-8 max-sm:w-8" data-tip="down">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2.5} stroke="currentColor" className="size-6">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="m9 12.75 3 3m0 0 3-3m-3 3v-7.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                                </svg>
                            </div>
                        </Tooltip>
                    )}
                    { result.result === 'draw' && (
                        <Tooltip disableFocusListener title={
                            <>
                                <div className='grid grid-cols-2 gap-1 font-bold text-yellow-500'>
                                    <span>결과:</span>
                                    <span className='uppercase'>{result.result === 'up' ? '업': result.result === 'down' ? '다운': '무승부'}</span>
                                    <span>시작가:</span>
                                    <span className='uppercase'>{result.draw_open_price}</span>
                                    <span>종료가:</span>
                                    <span className='uppercase'>{result.draw_close_price}</span>
                                    <span>요율 변화:</span>
                                    <span className='uppercase underline font-extrabold'>{result.result_percentage_change}</span>
                                </div>
                            </>
                        } arrow>
                            <div className="hover:cursor-pointer animate-on-load bg-gradient-to-t from-amber-900 from-10% to-80% h-10 w-10 flex items-center justify-center rounded-xl border-1 border-slate-600 aspect-square text-yellow-500 drop-shadow-md max-sm:h-8 max-sm:w-8" data-tip="draw">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2.5} stroke="currentColor" className="size-6">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M15 12H9m12 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                                </svg>
                            </div>
                        </Tooltip>
                    )}
                </div>
            ))}
                <Tooltip disableFocusListener title={
                    <>
                        <div className='grid grid-cols-1 gap-1 font-bold text-slate-300'>
                            <span>View daily history</span>
                        </div>
                    </>
                } arrow>

                    <div className="hover:cursor-pointer animate-on-load  h-10 w-10 flex items-center justify-center rounded-xl border-2 border-indigo-700 aspect-square text-slate-400 drop-shadow-md max-sm:h-8 max-sm:w-8" data-tip="view all history" onClick={() => openDrawHistory() }>
                        <svg xmlns="http://www.w3.org/2000/svg" width="29" height="29" fill="currentColor" className="bi bi-three-dots" viewBox="0 0 16 16">
                            <path d="M3 9.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3m5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3m5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3"/>
                        </svg>
                    </div>

                </Tooltip>
        </div>
    </>
}